import { render, staticRenderFns } from "./Negocios_Vehiculos.vue?vue&type=template&id=5f0d1a5a&scoped=true&"
import script from "./Negocios_Vehiculos.vue?vue&type=script&lang=js&"
export * from "./Negocios_Vehiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d1a5a",
  null
  
)

export default component.exports